import { DEFAULT_VALUE } from "@/config";
import type { Customer } from "@zhihaoscm/entity";
import type { CustomerJsonInfo } from "@zhihaoscm/entity";


export const getInfoFromCustomer = (customer?: Customer) => {
    if (!customer) return "";
    return `${customer.code} | ${customer.mobile ?? DEFAULT_VALUE} | ${customer.realName ?? DEFAULT_VALUE} | ${
        customer.institutionName ?? DEFAULT_VALUE
    }`;
};

/** 获取客户信息展示文本 */
export const getInfoFromCustomerJsonInfo = (customerInfo?: CustomerJsonInfo | Customer) => {
    if (!customerInfo) return DEFAULT_VALUE;
    return ` ${customerInfo.institutionName || customerInfo.realName || DEFAULT_VALUE} | ${customerInfo.mobile} | ${
        customerInfo.code || DEFAULT_VALUE
    }`;
};

/** 获取客户信息展示文本，只显示客户真实名称 */
export const getCustomerInfoStr = (customerInfo?: CustomerJsonInfo | Customer) => {
    if (!customerInfo) return DEFAULT_VALUE;

    const arr = [customerInfo.realName, customerInfo.mobile, customerInfo.code].filter(Boolean);
    return arr.join(" | ") || '--';
};
